import { render, staticRenderFns } from "./OnboardingIdentityPage.vue?vue&type=template&id=0ac61244&scoped=true&"
import script from "./OnboardingIdentityPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingIdentityPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingIdentityPage.vue?vue&type=style&index=0&id=0ac61244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac61244",
  null
  
)

export default component.exports